import type { ScanUpload, CBCTScanUpload } from '../../AttachScans/utils/Reloader.util';
import type { UploadedFile } from '@orthly/veneer';
import { atom } from 'jotai';

export const uploadFilesScansMapAtom = atom<Map<string, ScanUpload>>(new Map());
export const uploadFilesUploadedFilesAtom = atom<UploadedFile[]>([]);
export const uploadFilesCBCTScanFileAtom = atom<CBCTScanUpload | null>(null);
